import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  text-align: center;
  a {
    text-decoration: none !important;
    font-style: normal !important;
    text-align: left;
  }

  @media (max-width: 480px) {
    width: 300px;
    margin-bottom: 0.5rem;
  }
`
